import { defineMessages } from 'react-intl';

export default defineMessages({
  validate: {
    id: 'general.validate',
    defaultMessage: 'Valider',
  },
});
